var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import styles from './SuccessIcon.css';
var SuccessIcon = /** @class */ (function (_super) {
    __extends(SuccessIcon, _super);
    function SuccessIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuccessIcon.prototype.render = function () {
        return (<div className={styles['wrapper']}>
				<div className={styles['tick']}>
					<div className={styles['background']}></div>
					<div className={styles['tick-stem']}></div>
					<div className={styles['tick-branch']}></div>
				</div>
			</div>);
    };
    return SuccessIcon;
}(Component));
export default SuccessIcon;
